import React from "react"
import "../../styles/Pages/signup.css"
import { Outlet } from "react-router-dom"

const SignupLayout = ({ children }) => {
  return (
    <div className="login-bg-img">
      <div className="d-flex justify-content-center align-items-center h-100 w-100">
        <div className="login-container">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default SignupLayout
